import { Box } from '@aircall/tractor';

interface PageContainerProps {
  children: React.ReactNode;
  p?: string | number;
}

export function PageContainer({ children, p = '40px' }: PageContainerProps) {
  return (
    <Box p={p} height='100%' overflow='auto'>
      {children}
    </Box>
  );
}
